import script from "./PayinMoreDetailsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PayinMoreDetailsList.vue?vue&type=script&setup=true&lang=js"

import "./PayinMoreDetailsList.vue?vue&type=style&index=0&id=7328751c&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7328751c"]])

export default __exports__